module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-c1fbbab4.png";